<template>
  <div class="container-earning-rules" :style="{ paddingTop: topBarHeight + 'px', ...cssVars() }">
    <!-- Earning rules -->
    <van-nav-bar class="van-bar" :title="$t('lang.EarningRules.k003')" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.webp" alt="" @click-left="closeWeb" />
      </template>
    </van-nav-bar>
    <div class="main">
      <div v-for="(item, index) in list" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="con">{{ item.con }}</div>
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('lang.EarningRules.k004') }}</th>
              <th>{{ $t('lang.EarningRules.k007') }}</th>
              <th>{{ $t('lang.EarningRules.k005') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in item.tableTdList" :key="index">
              <td>{{ item.td1 }}</td>
              <td>{{ item.td2 }}</td>
              <td>{{ item.td3 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  data() {
    return {
      list: [
        {
          title: this.$t('lang.EarningRules.k008'),
          con: this.$t('lang.EarningRules.k001'),
          tableTdList: [
            {
              td1: this.$t('lang.BaseModule.k027'),
              td2: '0-29s',
              td3: '0%',
            },
            {
              td1: '',
              td2: '30s',
              td3: '100%',
            },
            {
              td1: this.$t('lang.BaseModule.k010'),
              td2: '0-60s',
              td3: '100%',
            },
          ],
        },
        {
          title: this.$t('lang.EarningRules.k006'),
          con: this.$t('lang.EarningRules.k002'),
          tableTdList: [
            {
              td1: this.$t('lang.BaseModule.k027'),
              td2: '0-9s',
              td3: '0%',
            },
            {
              td1: '',
              td2: '10-60s',
              td3: '100%',
            },
            {
              td1: this.$t('lang.BaseModule.k010'),
              td2: '0-60s',
              td3: '100%',
            },
          ],
        },
      ],
    }
  },
  created() {},
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>

<style lang="scss" scoped>
.container-earning-rules {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 20px;
  background: #080215;
  .main {
    margin: 0 12px;
    font-family: var(--number-font);
    .title {
      margin-top: 20px;
      color: #ffffff;
      font-size: var(--fs-14);
      font-weight: var(--fw-600);
      line-height: var(--lh-body-20);
    }
    .con {
      margin: 12px 0 16px 0;
      color: #ffffff;
      font-size: var(--fs-12);
      font-weight: var(--fw-400);
      line-height: var(--lh-label-16);
    }
    .table {
      width: 100%;
      border-collapse: collapse;
      text-align: center;
      background-color: #251b3c;
      tr {
        display: flex;
        th,
        td {
          flex: 1;
          color: #ffffff;
          font-size: var(--fs-12);
          font-weight: var(--fw-400);
          line-height: var(--lh-body-18);
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-family: var(--string-font);
  font-size: var(--fs-20);
  font-weight: var(--fw-900);
  line-height: var(--lh-title-24);
  color: #fff;
}
</style>
